if (!customElements.get('multicolumn-icon')) {
  customElements.define(
    'multicolumn-icon',
    class MulticolumnIcon extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.sectionEl = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        this.items = parseInt(this.dataset.items, 10);
        this.tabletItems = parseInt(this.dataset.tabletItems, 10);
        this.laptopItems = parseInt(this.dataset.laptopItems, 10);
        this.mobileItems = parseInt(this.dataset.mobileItems, 10) || 1;
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.autoplay = this.hasAttribute('autoplay');
        this.autoplaySpeed = this.hasAttribute('autoplay-speed')
          ? parseInt(this.getAttribute('autoplay-speed'), 10) * 1000
          : 5000;

        this.sliderInstance = false;
        this.blockSelectBound = false;

        if (!this.enableSlider && !this.enableSliderMobile) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.enableSliderMobile ? this.initSlider() : this.destroySlider();
        } else {
          this.enableSlider ? this.initSlider() : this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.sectionEl.querySelector(this.selectors.nextEl),
            prevEl: this.sectionEl.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.sectionEl.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: true,
          rewind: this.autoplay,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          autoplay: this.autoplay
            ? { delay: this.autoplaySpeed, pauseOnMouseEnter: true, disableOnInteraction: false }
            : false,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        const modules = [FoxTheme.Swiper.Mousewheel];
        if (this.autoplay) modules.push(FoxTheme.Swiper.Autoplay);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, modules);
        this.sliderInstance.init();

        if (Shopify.designMode && typeof this.sliderInstance === 'object' && !this.blockSelectBound) {
          this.blockSelectBound = true;
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            if (typeof this.sliderInstance !== 'object') return;
            const index = Number(e.target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
